import { render, staticRenderFns } from "./BloqueadorCodigos.vue?vue&type=template&id=13abb32c&scoped=true"
import script from "./BloqueadorCodigos.vue?vue&type=script&lang=js"
export * from "./BloqueadorCodigos.vue?vue&type=script&lang=js"
import style0 from "./BloqueadorCodigos.vue?vue&type=style&index=0&id=13abb32c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13abb32c",
  null
  
)

export default component.exports